import React from "react";
import { Text } from "@jsq/ds/core";

/**
 * Shared component for rendering empty/null values in AG Grid cells
 */
export const EmptyValueRenderer: React.FC = () => <Text variant="secondary-sm">—</Text>;

export default EmptyValueRenderer;
